import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { deepmerge } from 'deepmerge-ts'

import en from './locales/messages/en.json'
import th from './locales/messages/th.json'
import { getUserLocale } from './lib/i18n/getUserLocale'

export const defaultLocale = 'th'
export const supportedLocales = ['en', 'th']
export type Locale = (typeof supportedLocales)[number]

// Merge messages
const messages = deepmerge(en, th) as typeof en & typeof th

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      th: { translation: th },
    },
    lng: getUserLocale(),
    fallbackLng: defaultLocale,
    interpolation: {
      escapeValue: false,
    },
    defaultNS: 'translation',
    ns: ['translation'],
  })

export default i18n

